/*************************************************/
/* ANIMATIONS                                    */
/*************************************************/

export function animations() {

    // Cards animation
    const cardElements = document.querySelectorAll('.card-animation');
    const cardElementsObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const cardElement = entry.target;
            if (entry.isIntersecting) {
                cardElement.classList.add('fade-in-bottom-cards');
                return;
            }
        });
    });

    cardElements.forEach(card => {
        cardElementsObserver.observe(card);
    });

    // Media/Content animation
    const mediaContentElements = document.querySelectorAll('.media-content__image-animation');
    const mediaContentElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const mediaContentElement = entry.target;
            if (mediaContentElement.closest(".media-content__inner--invert")) {
                if (entry.isIntersecting) {
                    mediaContentElement.classList.add('fade-in-left');
                    return;
                }
            } else {
                if (entry.isIntersecting) {
                    mediaContentElement.classList.add('fade-in-right');
                    return;
                }
            }
        });
    });

    mediaContentElements.forEach(mediaContentElement => {
        mediaContentElementObserver.observe(mediaContentElement);
    });

    // Latest Articles animation
    const latestArticlesElements = document.querySelectorAll('.articles-list__item-animation');
    const latestArticlesElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const latestArticlesElement = entry.target;
            if (entry.isIntersecting) {
                latestArticlesElement.classList.add('fade-in-left-articles');
                return;
            }
        });
    });

    latestArticlesElements.forEach(latestArticlesElement => {
        latestArticlesElementObserver.observe(latestArticlesElement);
    });

    // Quote animation
    const quoteElements = document.querySelectorAll('.quote__source-container-animation');
    const quoteImageElements = document.querySelectorAll('.quote__source-image-animation');
    const quoteElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const quoteElement = entry.target;
            if (entry.isIntersecting) {
                quoteElement.classList.add('fade-in-right');
                return;
            }
        });
    });
    const quoteImageElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const quoteElement = entry.target;
            if (entry.isIntersecting) {
                quoteElement.classList.add('scale-in-center');
                return;
            }
        });
    });

    quoteElements.forEach(quoteElement => {
        quoteElementObserver.observe(quoteElement);
    });

    quoteImageElements.forEach(quoteElement => {
        quoteImageElementObserver.observe(quoteElement);
    });

    // Banner animations
    const articleBannerTagsElements = document.querySelectorAll('.banner__overlay-tags-animation');
    const bannerHeadlineElements = document.querySelectorAll('.banner__headline-xl-heading-animation');
    const bannerHeadlineSmallElements = document.querySelectorAll('.banner__headline-l-heading-animation');
    const articleBannerImageElements = document.querySelectorAll('.article-head__image-animation');
    const bannerTextElements = document.querySelectorAll('.banner__teaser-animation');
    const articleBannerTextElements = document.querySelectorAll('.banner__teaser-article-animation');
    const bannerLinkElements = document.querySelectorAll('.banner__link-animation');

    const articleBannerTagsElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const tagElement = entry.target;
            if (entry.isIntersecting) {
                tagElement.classList.add('fade-in-tags');
                return;
            }
        });
    });

    const bannerHeadlineElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const headlineElement = entry.target;
            if (entry.isIntersecting) {
                const words = headlineElement.textContent.split(' ');
                const newContent = words
                    .map((word, index) => `<span class="word-${index + 1}">${word}</span>`)
                    .join(' ');

                headlineElement.innerHTML = newContent;
                headlineElement.classList.add('fade-in-bottom');
                return;
            }

            headlineElement.innerHTML = headlineElement.textContent;
        });
    });

    const bannerHeadlineSmallElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const headlineSmallElement = entry.target;
            if (entry.isIntersecting) {
                const words = headlineSmallElement.textContent.split(' ');
                const newContent = words
                    .map((word, index) => `<span class="word-${index + 1}">${word}</span>`)
                    .join(' ');

                headlineSmallElement.innerHTML = newContent;
                headlineSmallElement.classList.add('fade-in-bottom');
                return;
            }

            headlineSmallElement.innerHTML = headlineSmallElement.textContent;
        });
    });

    const bannerTextElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const textElement = entry.target;
            if (entry.isIntersecting) {
                textElement.classList.add('fade-in-teaser');
                return;
            }
        });
    });

    const articleBannerTextElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const articleTextElement = entry.target;
            if (entry.isIntersecting) {
                articleTextElement.classList.add('fade-in-teaser-article');
                return;
            }
        });
    });

    const bannerLinkElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const linkElement = entry.target;
            if (entry.isIntersecting) {
                linkElement.classList.add('fade-in');
                return;
            }
        });
    });

    const articleBannerImageElementObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const imageElement = entry.target;
            if (entry.isIntersecting) {
                imageElement.classList.add('scale-in-hor-left');
                return;
            }
        });
    });

    articleBannerTagsElements.forEach(tagElement => {
        articleBannerTagsElementObserver.observe(tagElement);
    });

    bannerHeadlineElements.forEach(headlineElement => {
        bannerHeadlineElementObserver.observe(headlineElement);
    });

    bannerHeadlineSmallElements.forEach(headlineSmallElement => {
        bannerHeadlineSmallElementObserver.observe(headlineSmallElement);
    });

    bannerTextElements.forEach(textElement => {
        bannerTextElementObserver.observe(textElement);
    });

    articleBannerTextElements.forEach(articleTextElement => {
        articleBannerTextElementObserver.observe(articleTextElement);
    });

    bannerLinkElements.forEach(linkElement => {
        bannerLinkElementObserver.observe(linkElement);
    });

    articleBannerImageElements.forEach(imageElement => {
        articleBannerImageElementObserver.observe(imageElement);
    });
}